@if(loader){
<app-loader></app-loader>
}


<div class="login-container">
    <div class="login-left">
        <div class="welcome-box">
            <img src="assets/mapsoft_logo.jpeg" alt="Company Logo" class="company-logo">
            <h1>Welcome</h1>
            <h3 s>All-in-One Business Platform</h3>
            <p>Manage Purchasing, Sales, POS, CRM, Accounting, Inventory, and Manufacturing together in one cloud ERP
                with real-time insights.</p>
        </div>
    </div>

    <div class="login-right">
        <div class="login-form-card">
            <h2>Sign In</h2>
            <form [formGroup]="loginForm">
                <label for="username" class=" block label-required display"><i class="fa fa-user"></i> Username</label>
                <input formControlName="username" id="username" type="text" placeholder="Username" pInputText
                    class="input-field">

                <label for="password" class=" block label-required display">Password</label>
                <input formControlName="password" id="password" type="password" placeholder="Password" pInputText
                    class="input-field">

                @if(isShowTenant) {
                <label for="tenant" class=" block label-required display">Tenant</label> 
                <p-dropdown formControlName="tenant" (onChange)="setTenant()" [options]="tenants"
                    optionLabel="tenantName" placeholder="Select a Tenant" class="w-full mb-3" styleClass="w-full mb-3"
                    (keydown)="focusNextField($event, 'rememberme1')"></p-dropdown>
                }
                <div class="options">
                    <div class="remember-me">
                        <p-checkbox [binary]="true"></p-checkbox> 
                        <label> Remember me</label>
                    </div>
                    <a class="forgot">Forgot password?</a>
                </div>


                <button pButton pRipple (click)="login(loginForm.value)" label="Sign In" icon="pi pi-user"
                    class="signin-btn"></button>


            </form>
        </div>
    </div>
</div>

<p-toast></p-toast>